import React, { useState } from 'react';

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'white',
    zIndex: 2000,
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch'
  },
  toolbar: {
    position: 'sticky',
    top: 0,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 16px',
    background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)',
    zIndex: 100
  },
  toolbarBtn: {
    padding: '10px 16px',
    borderRadius: '8px',
    border: 'none',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer'
  },
  printBtn: {
    background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
    color: 'white'
  },
  closeBtn: {
    background: 'rgba(255,255,255,0.2)',
    color: 'white'
  },
  page: {
    width: '210mm',
    minHeight: '297mm',
    margin: '20px auto',
    padding: '15mm 12mm',
    background: 'white',
    boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
    boxSizing: 'border-box',
    fontFamily: 'Arial, sans-serif',
    fontSize: '11px',
    lineHeight: 1.4,
    pageBreakAfter: 'always'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '20px',
    paddingBottom: '15px',
    borderBottom: '3px solid #1e40af'
  },
  logo: {
    width: '120px',
    height: 'auto'
  },
  headerRight: {
    textAlign: 'right'
  },
  title: {
    fontSize: '22px',
    fontWeight: 700,
    color: '#1e40af',
    marginBottom: '4px'
  },
  subtitle: {
    fontSize: '12px',
    color: '#64748b'
  },
  section: {
    marginBottom: '20px'
  },
  sectionTitle: {
    fontSize: '13px',
    fontWeight: 700,
    color: 'white',
    background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
    padding: '8px 12px',
    marginBottom: '10px',
    borderRadius: '4px'
  },
  infoGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '8px'
  },
  infoRow: {
    display: 'flex',
    padding: '6px 10px',
    background: '#f8fafc',
    borderRadius: '4px',
    borderLeft: '3px solid #3b82f6'
  },
  infoLabel: {
    fontWeight: 600,
    color: '#334155',
    minWidth: '120px'
  },
  infoValue: {
    color: '#1e293b'
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '10px'
  },
  th: {
    padding: '8px 6px',
    textAlign: 'left',
    fontWeight: 600,
    background: '#e2e8f0',
    border: '1px solid #cbd5e1',
    color: '#334155'
  },
  td: {
    padding: '6px',
    border: '1px solid #cbd5e1',
    verticalAlign: 'top'
  },
  badge: {
    display: 'inline-block',
    padding: '2px 8px',
    borderRadius: '10px',
    fontSize: '9px',
    fontWeight: 600
  },
  badgeNC: {
    background: '#fef2f2',
    color: '#dc2626'
  },
  badgeObs: {
    background: '#fffbeb',
    color: '#d97706'
  },
  footer: {
    marginTop: '30px',
    paddingTop: '15px',
    borderTop: '2px solid #e2e8f0',
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '10px',
    color: '#64748b'
  },
  signatureBox: {
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    padding: '12px',
    minWidth: '200px',
    textAlign: 'center'
  },
  signatureLabel: {
    fontSize: '10px',
    color: '#64748b',
    marginBottom: '40px'
  },
  summaryBox: {
    display: 'flex',
    gap: '16px',
    marginBottom: '20px'
  },
  summaryItem: {
    flex: 1,
    padding: '12px',
    borderRadius: '8px',
    textAlign: 'center'
  },
  summaryNumber: {
    fontSize: '24px',
    fontWeight: 700
  },
  summaryLabel: {
    fontSize: '10px',
    marginTop: '4px'
  },
  noObservations: {
    textAlign: 'center',
    padding: '40px 20px',
    background: '#f0fdf4',
    borderRadius: '8px',
    border: '2px dashed #22c55e'
  }
};

function CertificatInspection({ mission, onClose }) {
  const [avecPhotos, setAvecPhotos] = useState(false);

  const etape1 = mission.etape_1_infos_generales || {};
  const etape8 = mission.etape_8_sources_energie || {};
  const etape11 = mission.etape_11_observations || {};
  
  const observations = etape11.observations || [];
  const dateVerification = mission.date_verification 
    ? new Date(mission.date_verification).toLocaleDateString('fr-FR')
    : new Date().toLocaleDateString('fr-FR');

  const typeVerif = (mission.type_verification || '').trim();
  const typeVerifLower = typeVerif.toLowerCase();
  const isTemporaire = typeVerif === "Vérification avant mise en service des installations temporaires en application de l'article R 4226-21 du Code du Travail";
  const isPeriodique = typeVerif === "Vérification périodique des installations électriques";
  const isInitiale = typeVerif === "Vérification initiale des installations électriques";
  const isMiseEnDemeureInspectionTravail = typeVerifLower.includes('mise en demeure')
    && (typeVerifLower.includes('inspection du travail') || typeVerifLower.includes('inspecteur du travail'));

  let titrePrincipal = "RAPPORT DE VÉRIFICATION PÉRIODIQUE";
  let sousTitre = "INSTALLATIONS ÉLECTRIQUES";
  let referenceReglementaire = null;
  if (isTemporaire) {
    titrePrincipal = "VÉRIFICATION INITIALE D'UNE INSTALLATION ÉLECTRIQUE TEMPORAIRE";
    sousTitre = null;
    referenceReglementaire = "(R4226-21)";
  } else if (isInitiale) {
    titrePrincipal = "RAPPORT DE VÉRIFICATION INITIALE";
    referenceReglementaire = "(R4226-14)";
  } else if (isMiseEnDemeureInspectionTravail) {
    titrePrincipal = "VÉRIFICATION SUR MISE EN DEMEURE À LA DEMANDE DE L'INSPECTION DU TRAVAIL";
    referenceReglementaire = "(R4722-26)";
  } else if (isPeriodique) {
    referenceReglementaire = "(R4226-14)";
  } else if (typeVerif) {
    titrePrincipal = typeVerif.toUpperCase();
    sousTitre = "INSTALLATIONS ÉLECTRIQUES";
  }

  // Compter les observations par gravité
  const countByGravite = observations.reduce((acc, obs) => {
    const g = obs.gravite || 'observation';
    acc[g] = (acc[g] || 0) + 1;
    return acc;
  }, {});

  // Source principale
  const sourcePrincipale = etape8.sources_bt?.[0] || {};

  const handlePrint = () => {
    window.print();
  };

  return (
    <div style={styles.overlay}>
      <style>{`
        @media print {
          .no-print { display: none !important; }
          body { margin: 0; padding: 0; }
          .print-page {
            width: 210mm !important;
            min-height: 297mm !important;
            margin: 0 !important;
            padding: 15mm 12mm !important;
            box-shadow: none !important;
            page-break-after: always !important;
          }
          .print-page:last-child {
            page-break-after: auto !important;
          }
        }
        @media screen and (max-width: 800px) {
          .print-page {
            width: 100% !important;
            min-height: auto !important;
            margin: 10px !important;
            padding: 16px !important;
          }
        }
      `}</style>

      {/* Toolbar - non imprimable */}
      <div style={styles.toolbar} className="no-print">
        <button 
          style={{...styles.toolbarBtn, ...styles.closeBtn}} 
          onClick={onClose}
        >
          ← Retour
        </button>
        <span style={{color: 'white', fontWeight: 600}}>Certificat d'Inspection</span>
        <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
          <select
            value={avecPhotos ? 'avec' : 'sans'}
            onChange={(e) => setAvecPhotos(e.target.value === 'avec')}
            style={{
              padding: '8px 10px',
              borderRadius: '8px',
              border: 'none',
              fontSize: '13px',
              fontWeight: 600,
              cursor: 'pointer',
              background: 'rgba(255,255,255,0.15)',
              color: 'white',
            }}
          >
            <option value="sans" style={{color: '#000'}}>Sans photos</option>
            <option value="avec" style={{color: '#000'}}>Avec photos (annexe)</option>
          </select>
          <button 
            style={{...styles.toolbarBtn, ...styles.printBtn}} 
            onClick={handlePrint}
          >
            🖨️ Imprimer / PDF
          </button>
        </div>
      </div>

      {/* PAGE 1 - Informations générales */}
      <div style={styles.page} className="print-page">
        {/* En-tête */}
        <div style={styles.header}>
          <div>
            <img 
              src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/68dbfcad1828a870cd470db1/60bf279fd_image.png" 
              alt="Logo" 
              style={styles.logo}
            />
          </div>
          <div style={styles.headerRight}>
            <div style={styles.title}>{titrePrincipal}</div>
            {sousTitre && <div style={styles.subtitle}>{sousTitre}</div>}
            {referenceReglementaire && (
              <div style={{...styles.subtitle, marginTop: '4px', fontWeight: 700, color: '#1e40af'}}>
                {referenceReglementaire}
              </div>
            )}
            <div style={{...styles.subtitle, marginTop: '8px', fontWeight: 600, color: '#1e40af'}}>
              N° {mission.numero_rapport || 'BROUILLON'}
            </div>
          </div>
        </div>

        {/* Résumé */}
        <div style={styles.summaryBox}>
          <div style={{...styles.summaryItem, background: '#fee2e2', color: '#dc2626'}}>
            <div style={styles.summaryNumber}>{countByGravite['non_conformite'] || 0}</div>
            <div style={styles.summaryLabel}>Non-conformité(s)</div>
          </div>
          <div style={{...styles.summaryItem, background: '#fef3c7', color: '#d97706'}}>
            <div style={styles.summaryNumber}>{countByGravite['observation'] || 0}</div>
            <div style={styles.summaryLabel}>Observation(s)</div>
          </div>
          <div style={{...styles.summaryItem, background: '#dbeafe', color: '#1e40af'}}>
            <div style={styles.summaryNumber}>{observations.length}</div>
            <div style={styles.summaryLabel}>Total</div>
          </div>
        </div>

        {/* Informations Client */}
        <div style={styles.section}>
          <div style={styles.sectionTitle}>📋 INFORMATIONS CLIENT</div>
          <div style={styles.infoGrid}>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Client :</span>
              <span style={styles.infoValue}>{mission.client_nom || '-'}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Établissement :</span>
              <span style={styles.infoValue}>{mission.etablissement || '-'}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Adresse :</span>
              <span style={styles.infoValue}>{mission.site_adresse || '-'}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Activité :</span>
              <span style={styles.infoValue}>{mission.activite_etablissement || '-'}</span>
            </div>
          </div>
        </div>

        {/* Informations Intervention */}
        <div style={styles.section}>
          <div style={styles.sectionTitle}>🔧 INTERVENTION</div>
          <div style={styles.infoGrid}>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Date :</span>
              <span style={styles.infoValue}>{dateVerification}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Type :</span>
              <span style={styles.infoValue}>{mission.type_verification || '-'}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Vérificateur :</span>
              <span style={styles.infoValue}>{mission.verificateur || '-'}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>N° Rapport :</span>
              <span style={styles.infoValue}>{mission.numero_rapport || 'BROUILLON'}</span>
            </div>
          </div>
        </div>

        {/* Caractéristiques Installation */}
        <div style={styles.section}>
          <div style={styles.sectionTitle}>⚡ CARACTÉRISTIQUES DE L'INSTALLATION</div>
          <div style={styles.infoGrid}>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Nature source :</span>
              <span style={styles.infoValue}>{sourcePrincipale.nature_designation || '-'}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Tension :</span>
              <span style={styles.infoValue}>{sourcePrincipale.tension ? `${sourcePrincipale.tension} V` : '-'}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Puissance :</span>
              <span style={styles.infoValue}>{sourcePrincipale.puissance ? `${sourcePrincipale.puissance} kVA` : '-'}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>SLT :</span>
              <span style={styles.infoValue}>{sourcePrincipale.schema_liaison_terre || '-'}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Intensité :</span>
              <span style={styles.infoValue}>{sourcePrincipale.intensite ? `${sourcePrincipale.intensite} A` : '-'}</span>
            </div>
            <div style={styles.infoRow}>
              <span style={styles.infoLabel}>Localisation :</span>
              <span style={styles.infoValue}>{sourcePrincipale.localisation || '-'}</span>
            </div>
          </div>
        </div>

        {/* Pied de page */}
        <div style={styles.footer}>
          <div>
            <div style={{fontWeight: 600}}>A2S PREVENTION</div>
            <div>7 rue Ambroise Croizat – 87920 Condat sur Vienne</div>
            <div>Accréditation COFRAC N° 3-2131</div>
          </div>
          <div style={{textAlign: 'right'}}>
            <div>Page 1/2</div>
            <div>Document généré le {new Date().toLocaleDateString('fr-FR')}</div>
          </div>
        </div>
      </div>

      {/* PAGE 2 - Observations */}
      <div style={styles.page} className="print-page">
        {/* En-tête simplifié */}
        <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '20px', paddingBottom: '10px', borderBottom: '2px solid #1e40af'}}>
          <div style={{fontWeight: 700, color: '#1e40af'}}>
            {titrePrincipal} - {mission.numero_rapport || 'BROUILLON'}
          </div>
          <div style={{color: '#64748b', fontSize: '10px'}}>
            {mission.client_nom} - {dateVerification}
          </div>
        </div>

        {/* Liste des observations */}
        <div style={styles.section}>
          <div style={styles.sectionTitle}>📝 LISTE DES OBSERVATIONS</div>
          
          {observations.length === 0 ? (
            <div style={styles.noObservations}>
              <div style={{fontSize: '32px', marginBottom: '12px'}}>✅</div>
              <div style={{fontWeight: 600, color: '#16a34a', fontSize: '14px'}}>
                Aucune observation relevée
              </div>
              <div style={{color: '#64748b', marginTop: '8px'}}>
                L'installation est conforme aux exigences réglementaires vérifiées.
              </div>
            </div>
          ) : (
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={{...styles.th, width: '40px'}}>N°</th>
                  <th style={{...styles.th, width: '100px'}}>Localisation</th>
                  <th style={styles.th}>Constat / Préconisation</th>
                  <th style={{...styles.th, width: '100px'}}>Référence</th>
                  <th style={{...styles.th, width: '60px'}}>Type</th>
                </tr>
              </thead>
              <tbody>
                {observations.map((obs, index) => (
                  <tr key={obs.id || index}>
                    <td style={{...styles.td, textAlign: 'center', fontWeight: 600}}>
                      {obs.numero || index + 1}
                    </td>
                    <td style={styles.td}>
                      {obs.localisation || '-'}
                    </td>
                    <td style={styles.td}>
                      <div style={{fontWeight: 500}}>{obs.titre || '-'}</div>
                      {obs.constat && (
                        <div style={{color: '#64748b', marginTop: '4px', fontSize: '9px'}}>
                          {obs.constat}
                        </div>
                      )}
                    </td>
                    <td style={{...styles.td, fontSize: '9px'}}>
                      {obs.reference_reglementaire || '-'}
                    </td>
                    <td style={{...styles.td, textAlign: 'center'}}>
                      <span style={{
                        ...styles.badge,
                        ...(obs.gravite === 'non_conformite' ? styles.badgeNC : styles.badgeObs)
                      }}>
                        {obs.gravite === 'non_conformite' ? 'NC' : 'OBS'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {/* Zone signature */}
        <div style={{...styles.footer, marginTop: 'auto'}}>
          <div style={styles.signatureBox}>
            <div style={styles.signatureLabel}>Signature du vérificateur</div>
            <div style={{fontWeight: 600}}>{mission.verificateur || '-'}</div>
          </div>
          <div style={styles.signatureBox}>
            <div style={styles.signatureLabel}>Signature du client</div>
            <div style={{fontWeight: 600}}>Nom et cachet</div>
          </div>
        </div>

        {/* Pied de page */}
        <div style={{...styles.footer, borderTop: 'none', marginTop: '20px'}}>
          <div style={{fontSize: '9px', color: '#94a3b8'}}>
            Ce certificat est délivré à titre provisoire. Le rapport complet sera disponible après validation.
          </div>
          <div>Page {avecPhotos ? '2/...' : '2/2'}</div>
        </div>
      </div>

      {/* PAGE(S) ANNEXE PHOTOGRAPHIQUE — optionnelle */}
      {avecPhotos && (() => {
        // Construire la liste à plat des photos avec leur contexte
        const photosFlat = [];
        observations.forEach((obs) => {
          (obs.photos || []).forEach((url, idx) => {
            if (url && typeof url === 'string' && url.trim()) {
              photosFlat.push({
                url: url.trim(),
                obsNumero: obs.numero ?? '?',
                obsLocalisation: obs.localisation || '',
                obsConstat: obs.constat || obs.titre || '',
                photoIndex: idx + 1,
              });
            }
          });
        });

        if (photosFlat.length === 0) {
          return (
            <div style={{...styles.page}} className="print-page">
              <div style={{textAlign: 'center', color: '#94a3b8', padding: '40px'}}>
                Aucune photo disponible pour les observations de ce rapport.
              </div>
            </div>
          );
        }

        const PHOTOS_PER_PAGE = 6;
        const totalAnnexePages = Math.ceil(photosFlat.length / PHOTOS_PER_PAGE);

        return Array.from({ length: totalAnnexePages }, (_, pageIdx) => {
          const pagePhotos = photosFlat.slice(pageIdx * PHOTOS_PER_PAGE, (pageIdx + 1) * PHOTOS_PER_PAGE);
          return (
            <div key={`annexe-${pageIdx}`} style={styles.page} className="print-page">
              {/* En-tête */}
              <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '14px', paddingBottom: '8px', borderBottom: '2px solid #1e40af'}}>
                <div style={{fontWeight: 700, color: '#1e40af'}}>
                  ANNEXE PHOTOGRAPHIQUE — {mission.numero_rapport || 'BROUILLON'}
                  {totalAnnexePages > 1 && ` (${pageIdx + 1}/${totalAnnexePages})`}
                </div>
                <div style={{color: '#64748b', fontSize: '10px'}}>
                  {mission.client_nom} - {dateVerification}
                </div>
              </div>

              <div style={{fontSize: '10px', color: '#64748b', marginBottom: '12px'}}>
                Photographies associées aux observations relevées lors de la vérification
              </div>

              {/* Grille 2×3 */}
              <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', flex: 1}}>
                {pagePhotos.map((photo, i) => (
                  <div key={i} style={{border: '1px solid #e2e8f0', borderRadius: '6px', overflow: 'hidden', display: 'flex', flexDirection: 'column'}}>
                    <div style={{background: '#f8fafc', display: 'flex', alignItems: 'center', justifyContent: 'center', height: '140px', overflow: 'hidden'}}>
                      <img
                        src={photo.url}
                        alt={`Obs. N°${photo.obsNumero}`}
                        style={{maxWidth: '100%', maxHeight: '140px', objectFit: 'contain'}}
                        onError={(e) => { e.target.style.display = 'none'; }}
                      />
                    </div>
                    <div style={{background: '#eff6ff', borderTop: '1px solid #bfdbfe', padding: '5px 8px'}}>
                      <div style={{fontWeight: 700, fontSize: '9px', color: '#1e40af'}}>
                        Obs. N°{photo.obsNumero}
                        {photo.obsLocalisation && ` — ${photo.obsLocalisation}`}
                      </div>
                      {photo.obsConstat && (
                        <div style={{fontSize: '8px', color: '#475569', marginTop: '2px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                          {photo.obsConstat.length > 80 ? photo.obsConstat.slice(0, 80) + '…' : photo.obsConstat}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              <div style={{...styles.footer, borderTop: 'none', marginTop: '20px'}}>
                <div style={{fontSize: '9px', color: '#94a3b8'}}>
                  Ce certificat est délivré à titre provisoire. Le rapport complet sera disponible après validation.
                </div>
                <div>Annexe photos — Page {2 + pageIdx + 1}/{2 + totalAnnexePages}</div>
              </div>
            </div>
          );
        });
      })()}
    </div>
  );
}

export default CertificatInspection;